export class BaseParameterDto {
  clearCache: boolean = false;

  getQueryString(): string {
    return `?clearCache=${this.clearCache}`;
  }
}
